export const CHANCE_ACTION_TYPES = {
  GET_CHANCE: 'chance/getChance',
  SET_CHANCE: 'chance/setChance',
  PARTICIPATE: 'chance/participate',
};
